import React, { useState, useEffect } from "react";
import "../../../css/CRUDModal.css";
import { apiList } from "../../../helpers/apiList";
import CustomAlert from "../../../helpers/CustomAlert";
import {
  axiosGetApi,
  axiosPostApi,
} from "../../../helpers/interceptorServices";
import AddVectorIcon from "../../../assets/Icons/Add Vector.png";
import LeftCircle from "../../../assets/Icons/Left circle B.png";
import RightCircle from "../../../assets/Icons/Right circle A.png";
import CrossIcon from "../../../assets/Icons/cross_svg.svg";
import ModalInput from "../../../components/ModalInput/ModalInput";
import CurrencyRupeeIcon from "@mui/icons-material/CurrencyRupee";
import PercentIcon from "@mui/icons-material/Percent";
import ProductionQuantityLimitsIcon from "@mui/icons-material/ProductionQuantityLimits";
import Dropdown from "../../../components/Dropdown";
import { useDashboardData } from "../../../Hooks/useDashboardData";
import { useSelector } from "react-redux";

const BuyStationaryModal = ({
  show,
  handleClose,
  callApi,
  editData,
  action,
  handleAction,
}) => {
  const loggedInUserName = sessionStorage.getItem("username");
  const { user } = useSelector((state) => state.auth);
  // Hubs cannot buy AWB stickers (the backend refuses them too)
  const isHub = user?.data?.userProfile === "HUB";
  const { fetchDashboardData } = useDashboardData();

  const [formData, setFormData] = useState({
    itemCode: "",
    itemName: "",
    unitRate: "",
    gstPercent: "",
    minQuantity: "",
    isActive: true,
  });

  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [itemOptions, setItemOptions] = useState([]);
  const [quantity, setQuantity] = useState("");
  const [totalAmount, setTotalAmount] = useState(0);

  const isAddMode = action === "add";
  const isEditMode = action === "modify";
  const isViewMode = action === "view";
  const isDeleteMode = action === "delete";
  const isApproveRejectMode = action === "approve/reject";
  const isReadOnly = isViewMode || isDeleteMode || isApproveRejectMode;

  // ================= INIT =================
  useEffect(() => {
    if (action === "add") {
      setFormData({
        itemCode: "",
        itemName: "",
        unitRate: "",
        gstPercent: "",
        minQuantity: "",
        isActive: true,
      });
    } else if (editData) {
      const qty = editData?.quantityE || "";
      const rate = editData?.unitRateE || 0;
      const gst = editData?.gstPercent || 0;

      const item = {
        itemCode: editData.itemCode,
        unitRate: editData.unitRate,
        gstPercent: editData.gstPercent,
      };

      setFormData({
        itemCode: editData?.itemCode || "",
        itemName: editData?.itemName || "",
        unitRate: editData?.unitRateE || "",
        gstPercent: editData?.gstPercent || "",
        minQuantity: editData?.quantityE || "",
        isActive: editData?.isActive === "Active" ? true : false,
      });
      setQuantity(editData?.quantityE || "");
      setItemOptions([item])
      calculateTotal(qty, rate, gst);
    }
    setErrors({});
  }, [show]);

  useEffect(() => {
    if (!show) return;
    if (action === "add" || action === "modify"){
      fetchItems();
    }
  }, [show]);

  const fetchItems = async () => {
    try {
      const response = await axiosGetApi(
        `${apiList.GET_STATIONARY_ITEMS_DETAILS}?username=${loggedInUserName}`,
      );

      if (
        response?.data?.status === true &&
        response?.data?.respCode === "00"
      ) {
        const items = response.data.data || [];
        setItemOptions(
          isHub ? items.filter((item) => item?.itemCode !== "AWB") : items,
        );
        // expected format:
        // [{ itemCode: "AIR", rate: 10, gst: 18 }]
      }
    } catch (err) {
      console.error("Item fetch error", err);
    }
  };

  const handleItemSelect = (item) => {
    setFormData((prev) => ({
      ...prev,
      itemCode: item.itemCode,
      unitRate: item.unitRate,
      gstPercent: item.gstPercent,
    }));

    handleFieldBlur("itemCode", item.itemCode);
    calculateTotal(quantity, item.unitRate, item.gstPercent);
  };

  const calculateTotal = (qty, rate, gst) => {
    if (!qty || !rate) return setTotalAmount(0);

    const base = Number(qty) * Number(rate);
    const gstAmount = (base * Number(gst)) / 100;
    setTotalAmount((base + gstAmount).toFixed(2));
  };

  const handleQtyChange = (e) => {
    const val = e.target.value.replace(/\D/g, "");
    setQuantity(val);

    calculateTotal(val, formData.unitRate, formData.gstPercent);
  };

  // ================= VALIDATION =================
  const validateForm = () => {
    const newErrors = {};

    Object.keys(validationRules).forEach((field) => {
      const value = field === "quantity" ? quantity : formData[field];
      const error = validateField(field, value);
      if (error) newErrors[field] = error;
    });

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleFieldBlur = (field, value) => {
    const error = validateField(field, value);

    setErrors((prev) => {
      const next = { ...prev };
      if (error) next[field] = error;
      else delete next[field];
      return next;
    });
  };

  // ================= VALIDATION RULES =================
  const validationRules = {
    itemCode: (v) => (!v ? "Please select item code" : ""),
    quantity: (v) => {
      if (!v) return "Quantity required";
      if (!/^\d+$/.test(v)) return "Only numbers allowed";
      if (Number(v) <= 0) return "Must be greater than 0";
      return "";
    },
  };

  const validateField = (field, value) => {
    const validator = validationRules[field];
    return validator ? validator(value) : "";
  };

  const handleBack = () => {
    handleClose();
    setErrors({});
  };

  // ================= SUBMIT =================
  const handleSubmit = async () => {
    if (!validateForm()) return;

    // const isAdd = action === "add";
    // const apiUrl = isAdd
    //   ? apiList.CREATE_BUY_STATIONARY_MASTER
    //   : apiList.MODIFY_BUY_STATIONARY_MASTER;

    // const payload = isAdd
    //   ? {
    //       username: loggedInUserName,
    //       itemCode: formData.itemCode,
    //       quantity: Number(quantity),
    //       rate: Number(formData.unitRate),
    //       gst: Number(formData.gstPercent),
    //       totalAmount: Number(totalAmount),
    //     }
    //   : {
    //       username: loggedInUserName,
    //       id: editData?.id,
    //       itemName: formData.itemName,
    //       unitRate: Number(formData.unitRate),
    //       gstPercent: Number(formData.gstPercent),
    //       minQuantity: Number(formData.minQuantity),
    //       isActive: editData?.isActive === "Active" ? true : false,
    //     };

    const apiUrl = formData?.itemCode === "AWB" 
    ? apiList.BARCODE_REQUEST 
    : apiList?.CREATE_BUY_STATIONARY_MASTER;

    const payload = {
      username: loggedInUserName,
      itemCode: formData.itemCode,
      quantity: Number(quantity),
    };

    try {
      setLoading(true);
      const res = await axiosPostApi(apiUrl, payload);

      if (res?.data?.status) {
        CustomAlert({
          title: res.data.message,
          icon: "success",
        }).then(() => {
          fetchDashboardData()
        });
        callApi(1);
        handleClose();
      } else {
        CustomAlert({
          title: "Failed",
          text: res?.data?.message,
          icon: "error",
        });
      }
    } catch (err) {
      CustomAlert({
        title: "Error",
        text: "Something went wrong",
        icon: "error",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {show && (
        <div
          style={{
            position: "fixed",
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
            backgroundColor: "rgba(0,0,0,0.4)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 1031,
          }}
        >
          <div className="modal-dialog" role="document">
            <div className="modal-content w-[500px] min-h-fit h-[241px] rounded-3xl p-6 bg-white border border-gray-200">
              <img
                src={LeftCircle}
                alt="leftImg"
                className="absolute left-0 bottom-0 w-[110px] h-[105px]"
              />
              <img
                src={RightCircle}
                alt="leftImg"
                className="absolute right-0 top-0 w-[110px] h-[105px]"
              />
              <div className="modal-header flex items-center justify-between border-b-0 mb-3">
                <div className="flex items-center">
                  <img
                    src={AddVectorIcon}
                    alt="Add Icon"
                    className="w-[43px] h-[38px] mr-2"
                  />
                  <h5 className="modal-title main-title font-medium text-lg">
                    Buy Stationary
                  </h5>
                </div>
                <img
                  src={CrossIcon}
                  alt="filter icon"
                  className="w-[30px] h-[30px] cursor-pointer z-20"
                  onClick={handleBack}
                />
              </div>
              <form>
                <div className="modal-body space-y-4 items-center">
                  <div className="grid grid-cols-2 gap-4">
                    {/* Item Code Dropdown */}
                    <div className="form-group">
                      {/* <label>Item Code<span className="text-red-500">*</span></label>
                    <ItemDropdown
                      options={itemOptions}
                      selected={formData.itemCode}
                      onSelect={handleItemSelect}
                    /> */}
                      <Dropdown
                        label="Stationary Code"
                        options={itemOptions}
                        value={formData.itemCode}
                        disabled={isReadOnly}
                        onChange={(item) => {
                          handleItemSelect(item);
                          handleFieldBlur("itemCode", item.itemCode);
                        }}
                        labelKey="itemCode"
                        valueKey="itemCode"
                        placeholder="Select Stationary Code"
                        error={errors.itemCode}
                        isRequired
                      />
                    </div>

                    {/* Quantity */}
                    <ModalInput
                      id="quantity"
                      label="Quantity To Buy"
                      value={quantity}
                      onChange={(e) => {
                        handleQtyChange(e);
                        handleFieldBlur("quantity", e.target.value);
                      }}
                      error={errors.quantity} // ✅ ADD THIS
                      placeholder="Enter Quantity"
                      Icon={ProductionQuantityLimitsIcon}
                      alignRight
                      disabled={isReadOnly}
                    />

                    {/* Per Qty Rate */}
                    <ModalInput
                      id="unitRate"
                      label="Per Qty Rate (₹)"
                      value={formData.unitRate}
                      disabled
                      Icon={CurrencyRupeeIcon}
                      alignRight
                      required={false}
                    />

                    {/* GST */}
                    <ModalInput
                      id="gstPercent"
                      label="GST %"
                      value={formData.gstPercent}
                      disabled
                      Icon={PercentIcon}
                      alignRight
                      required={false}
                    />

                    {/* Total Amount */}
                    <ModalInput
                      id="totalAmount"
                      label="Total Amount"
                      value={totalAmount}
                      disabled
                      Icon={CurrencyRupeeIcon}
                      alignRight
                      required={false}
                    />

                    {/* Remarks */}
                    {editData?.remarks && editData?.remarks !== "-" && (
                      <ModalInput
                        id="remarks"
                        label="Remarks"
                        value={editData?.remarks}
                        disabled
                        required={false}
                      />
                    )}
                  </div>
                </div>

                <div className="flex justify-center gap-4 pt-4 border-t-0">
                  <button
                    type="button"
                    className="btn btn-back w-[133px] h-[33px] !rounded-[8px] flex items-center justify-center"
                    onClick={handleBack}
                  >
                    Back
                  </button>
                  {!isReadOnly && (action === "add" || action === "modify") && (
                    <button
                      type="button"
                      className="btn btn-submit w-[133px] h-[33px] !rounded-[8px] flex items-center justify-center"
                      onClick={handleSubmit}
                      disabled={loading}
                    >
                      Submit
                    </button>
                  )}
                  {isApproveRejectMode && (
                      <div className="flex gap-4">
                        {(editData?.status || "").toUpperCase() === "APPROVED" ? (
                            <button
                                type="button"
                                className="btn btn-danger w-[140px] h-[33px] !rounded-[8px] flex items-center justify-center"
                                onClick={() => handleAction("CANCELLED")}
                                disabled={loading}
                            >
                              Cancel Request
                            </button>
                        ) : (editData?.status || "").toUpperCase() === "PENDING" ? (
                            <>
                              <button
                                  type="button"
                                  className="btn btn-submit w-[133px] h-[33px] !rounded-[8px] flex items-center justify-center"
                                  onClick={() => handleAction("APPROVED")}
                                  disabled={loading}
                              >
                                Approve
                              </button>
                              <button
                                  type="button"
                                  className="btn btn-danger w-[133px] h-[33px] !rounded-[8px] flex items-center justify-center"
                                  onClick={() => handleAction("REJECTED")}
                                  disabled={loading}
                              >
                                Reject
                              </button>
                            </>
                        ) : null}
                      </div>
                  )}
                </div>
              </form>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default BuyStationaryModal;
